import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { FlowsDisplayGridRowDataFragmentGql } from './FlowsDisplayGridRowDataFragmentGql';

export const TableUpstreamFlowsFilteredByColumnQueryGql: DocumentNode = gql`
query TableUpstreamFlowsFilteredByColumnQuery($tableId: ID!, $columnId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  tables(filter: { id: $tableId }) {
    columns(filter: { id: $columnId }) {
      upstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...FlowsDisplayGridRowDataFragment
        }
      }
    }
  }
}
${FlowsDisplayGridRowDataFragmentGql}
`;
